import { defineClickEventHandler } from './DefineClickEvent';
import { defineRedirectOnPersistEventHandler } from './DefineRedirectOnPersistEvent';
import { removeClickEventHandler } from './RemoveClickEvent';
export * from './DefineClickEvent';
export * from './DefineRedirectOnPersistEvent';
export * from './eventInstruction';
export * from './RemoveClickEvent';
export const eventStmtHandlers = [defineClickEventHandler, defineRedirectOnPersistEventHandler, removeClickEventHandler];
//# sourceMappingURL=index.js.map